<script>
import ProjectMomService from "@/services/ProjectMomService";
import Cloner from "@/libraries/Cloner";

export default {
    props: {
        projectId: {},
        momId: {}
    },
    data() {
        return {
            loading: true,
            saving: false,
            editing: false,
            errors: {},
            entity: {
                id: null,
                project_id: null,
                title: null,
                held_date: null,
                location: null
            }
        };
    },
    async created() {
        this.entity.project_id = this.projectId;

        if (this.momId) {
            await this.fetchData();
            this.editing = true;
        }

        this.loading = false;
    },
    mounted() {
        this.$nextTick(() => {
            const input = this.$refs.firstInput?.$el.querySelector("input");
            if (input) input.focus();
        });
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await ProjectMomService.GETS(this.momId);
                this.entity = Cloner.pickClone(data.data, [
                    "id",
                    "project_id",
                    "title",
                    "held_date",
                    "location"
                ]);
            } catch (e) {
                console.log("VProjectMomForm fetchData e", e);
            }
        },
        async saveForm() {
            try {
                this.saving = true;
                this.errors = {};

                if (this.editing) {
                    await ProjectMomService.PUT(this.entity);
                    this.$emit("close-reload");
                } else {
                    const { data } = await ProjectMomService.POST(this.entity);
                    this.$emit("created", data.data);
                }
            } catch (e) {
                this.errors = e.response.data.errors;
            }

            this.saving = false;
        }
    }
};
</script>

<template>
    <modal
        :show="true"
        @close="$emit('close')"
        class="budget-modal"
        :loading="loading"
    >
        <template slot="header">
            <template v-if="editing">{{
                $t("moms.modal_title_edit")
            }}</template>
            <template v-else>{{ $t("moms.modal_title_create") }}</template>
        </template>

        <template slot="default">
            <FormulateForm v-model="entity" @submit="saveForm" :errors="errors">
                <div class="row">
                    <FormulateErrors />
                    <div class="col-12">
                        <FormulateInput
                            type="text"
                            ref="firstInput"
                            name="title"
                            :label="$t('moms.field_title')"
                            :validation-name="$t('moms.field_title')"
                            validation="required"
                        />
                    </div>
                    <div class="col-12">
                        <FormulateInput
                            type="date"
                            name="held_date"
                            :label="$t('moms.field_date')"
                            :validation-name="$t('moms.field_date')"
                            validation="required"
                        />
                    </div>
                    <div class="col-12">
                        <FormulateInput
                            type="textarea"
                            name="location"
                            :label="$t('moms.field_location')"
                        />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col text-right">
                        <base-button
                            type="secondary"
                            :outline="true"
                            @click="$emit('close')"
                            >{{ $t("cancel") }}</base-button
                        >
                        <base-button
                            type="primary"
                            :loading="saving"
                            native-type="submit"
                            >{{ $t("save") }}</base-button
                        >
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>
